import { useCallback, useEffect, useState } from "react";
import axios from "axios";

// PUNT 5, 11 oktober 2026: DE WEIGERING BLIJFT BEWAARD NA HERLADEN. Tot die dag
// haalde een herladen kaart meteen een vers token, en dan stond er weer een
// gewone oranje Bevestig zonder melding - terwijl de kaart net was geweigerd.
// Bewaard OP DIT APPARAAT, per kaartadres, en niet op de server: dat zou een
// schemawijziging in vier tabellen vragen. Alleen "Open opnieuw" haalt de
// weigering weg, en dat is dezelfde regel als fix 4.
export const WEIGERING = "novamund_kaart_geweigerd:";

function leesWeigering(url) {
  try {
    const ruw = url ? localStorage.getItem(WEIGERING + url) : null;
    return ruw ? JSON.parse(ruw) : null;
  } catch {
    return null;
  }
}

function zetWeigering(url, reden) {
  try {
    if (url) localStorage.setItem(WEIGERING + url, JSON.stringify({ reden: reden || "", at: Date.now() }));
  } catch { /* geen opslag: de kaart is dan nog steeds grijs tot herladen */ }
}

function wisWeigering(url) {
  try { if (url) localStorage.removeItem(WEIGERING + url); } catch { /* niets te wissen */ }
}

/** Een Bevestig na een weigering: echt grijs en niet klikbaar, niet donkerder oranje. */
export const GRIJS = "bg-muted text-muted-foreground hover:bg-muted cursor-not-allowed opacity-100 shadow-none";

/**
 * Het WF-40-token van een bevestigingskaart. Post a van de batch.
 *
 * Zodra de kaart te bevestigen is (`actief`), haalt zij bij `url` een vers token
 * op. Alleen met dat token doet Bevestig iets, en een kaart die elders opnieuw
 * wordt geopend laat dit token vervallen.
 *
 * Een mislukt ophalen laat het token LEEG, en een kaart zonder token houdt haar
 * Bevestig-knop dicht: weigeren bij twijfel.
 *
 * **FIX 4, FRANKS GLASRONDE VAN 11 OKTOBER 2026: NA EEN WEIGERING GEEN STIL
 * NIEUW TOKEN.** Hier stond dat een kaart na een mislukte poging zelf een vers
 * token ophaalde. Dan bleef Bevestig oranje, en een tweede klik op een scherm
 * dat elders al vervangen was, ging alsnog door. `laatVervallen` maakt het token
 * leeg en zet `vervallen`; alleen een uitdrukkelijke "Open opnieuw" (`vernieuw`)
 * haalt een nieuw. De regels van WF-40 zelf staan op de server en zijn niet
 * veranderd.
 */
export function useKaartToken(url, actief) {
  const [token, setToken] = useState("");
  const [vervallen, setVervallen] = useState(false);
  const [reden, setReden] = useState("");

  const vernieuw = useCallback(async () => {
    if (!url) return "";
    wisWeigering(url);
    setReden("");
    try {
      const r = await axios.post(url);
      const vers = r?.data?.token || "";
      setToken(vers);
      setVervallen(!vers);
      return vers;
    } catch {
      setToken("");
      setVervallen(true);
      return "";
    }
  }, [url]);

  const laatVervallen = useCallback((waarom = "") => {
    setToken("");
    setVervallen(true);
    setReden(waarom);
    zetWeigering(url, waarom);
  }, [url]);

  useEffect(() => {
    const eerder = actief ? leesWeigering(url) : null;
    if (eerder) {
      setToken("");
      setVervallen(true);
      setReden(eerder.reden || "");
    } else if (actief) vernieuw();
    else {
      setToken("");
      setVervallen(false);
    }
  }, [actief, vernieuw, url]);

  return { token, vernieuw, vervallen, laatVervallen, reden };
}
